import Component from './Component';
import { onScroll, onResizeDebounced } from '../services/ScrollResizeHandler';
import { isInViewport } from '../utilities/is_in_viewport';
import { createGradient } from '../utilities/create_gradient';
import ProgressBar from 'progressbar.js';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

const circularGraphs = [];
let newCircularGraph;
let elmInViewport;
let gradientColor;
let rafTimer;

let linearGradientBlue = [
    { offset: '30%', 'stop-color': '#0099ae'},
    { offset: '60%', 'stop-color': '#004e77'}
]

let linearGradientGreen = [
    { offset: '30%', 'stop-color': '#ede100'},
    { offset: '60%', 'stop-color': '#7db51c'}
]


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */





/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class CircularGraph extends Component {

    decorator () {
        return {
            selector : '.js-circular-graph',
            name : 'CircularGraph',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        this.renderGraph();

        this.startAnimation();

        onScroll(this.startAnimation.bind(this));

        onResizeDebounced(this.startAnimation.bind(this));
    }


    cacheElements () {
        this.graphColor = this.element.getAttribute('data-graph-color');
    }


    // INIT GRAPH
    renderGraph () {
        let circleContainer;
        let gradientColor = this.graphColor == 'blue' ? 'url(#linearGradientBlue)' : 'url(#linearGradientGreen)';
        let gradientElement = this.graphColor == 'blue' ? linearGradientBlue : linearGradientGreen;
        let gradientID = this.graphColor == 'blue' ? 'linearGradientBlue' : 'linearGradientGreen';

        newCircularGraph = new ProgressBar.Circle(this.element, {
            color: gradientColor,
            strokeWidth: 16,
            trailWidth: 0,
            trailColor: '#ffffff',
            easing: 'easeInOut',
            duration: 2500,
            text: {
                autoStyleContainer: false,
                style: false
            },
            step: (state, circle) => {
                let perc = Math.round(circle.value() * 100);

                circleContainer = circle._container.querySelector('.js-circular-graph-digit');

                if (perc === 0) {
                    circleContainer.innerText = 0;
                } else {
                    circleContainer.innerText = perc;
                }

                if (perc == circle._container.getAttribute('data-graph-digit')) {
                    circle.stop();
                }
            }
        });

        createGradient(newCircularGraph.svg, gradientID, gradientElement)

        circularGraphs.push(newCircularGraph);

    }


    // START ANIMATION
    startAnimation () {
        const checkIfElementIsInViewport = () => {

            for (let i = 0; i < circularGraphs.length; i++) {
                let isActivated = false;
                const container = circularGraphs[i]._container;
                const value = circularGraphs[i]._container.getAttribute('data-graph-digit') * 0.010;
                const elmInViewport = isInViewport(circularGraphs[i]._container);

                if (elmInViewport && isActivated == false) {
                    circularGraphs[i].animate(value);
                    isActivated = true;
                }
            }
        }

        cancelAnimationFrame(rafTimer);

        rafTimer = window.requestAnimationFrame(checkIfElementIsInViewport);
    }

}
